import{useState}from'react'

export default function EmailParser({onDataExtracted}){
const[emailText,setEmailText]=useState('')
const[parsing,setParsing]=useState(false)
const[result,setResult]=useState(null)

async function parseEmail(){
setParsing(true)
try{
const response=await fetch('/api/parse-email',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({emailText})})
const data=await response.json()
const text=data.content[0].text
const clean=text.replace(/\`\`\`json|\`\`\`/g,'').trim()
const parsed=JSON.parse(clean)
setResult(parsed)
}catch(err){
console.error(err)
}
setParsing(false)}

return(<div>
<textarea
value={emailText}
onChange={e=>setEmailText(e.target.value)}
placeholder='Paste your email thread here...'
style={{width:'100%',minHeight:'200px',padding:'12px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px',fontFamily:'inherit',resize:'vertical',boxSizing:'border-box',marginBottom:'12px'}}
/>
<button className='btn-primary' onClick={parseEmail} disabled={parsing||!emailText}>
{parsing?'Parsing...':'Parse Email'}
</button>
{result&&(
<div style={{marginTop:'1.5rem',background:'#f8fdf9',border:'1px solid #c8e6d4',borderRadius:'8px',padding:'1.25rem'}}>
<p style={{fontSize:'13px',fontWeight:'600',marginBottom:'12px',color:'#1a6b4a'}}>Extracted Data</p>
{Object.entries(result).filter(([k,v])=>v!==null).map(([key,value])=>(
<div key={key} style={{display:'flex',justifyContent:'space-between',padding:'4px 0',fontSize:'13px',borderBottom:'1px solid #e8f5ef'}}>
<span style={{color:'#666',textTransform:'capitalize'}}>{key.replace(/_/g,' ')}</span>
<span style={{fontWeight:'500'}}>{String(value)}</span>
</div>
))}
<button className='btn-primary' style={{marginTop:'1rem',width:'100%'}} onClick={()=>onDataExtracted(result)}>
Apply to Event
</button>
</div>
)}
</div>)}